import React from 'react';
import cx from 'classnames';
import WithSx from '../../hoc/WithSX/WithSx';
import { propTypes, defaultProps } from './props';

/**
 * @component Block
 */
import { jsx as ___EmotionJSX } from "@emotion/react";
const Block = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    dir,
    className,
    sx,
    onClick,
    onFocus,
    onBlur,
    onMouseEnter,
    onMouseLeave
  } = props;
  return ___EmotionJSX("div", {
    dir: dir,
    ref: ref,
    css: sx,
    className: cx('block', className),
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
});
Block.displayName = 'Block';
Block.propTypes = propTypes;
Block.defaultProps = defaultProps;
export default WithSx(Block, {});